import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_06ef2212 from 'nuxt_plugin_plugin_06ef2212' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_554e15bc from 'nuxt_plugin_bootstrapvue_554e15bc' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_recaptcha_e784d708 from 'nuxt_plugin_recaptcha_e784d708' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7b38fa35 from 'nuxt_plugin_cookieuniversalnuxt_7b38fa35' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_0358148d from 'nuxt_plugin_axios_0358148d' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_axios_2228ef02 from 'nuxt_plugin_axios_2228ef02' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_anonaxios_2254e5b6 from 'nuxt_plugin_anonaxios_2254e5b6' // Source: ../plugins/anonaxios (mode: 'all')
import nuxt_plugin_vuelidate_0f19c03d from 'nuxt_plugin_vuelidate_0f19c03d' // Source: ../plugins/vuelidate (mode: 'all')
import nuxt_plugin_buefy_22359951 from 'nuxt_plugin_buefy_22359951' // Source: ../plugins/buefy (mode: 'all')
import nuxt_plugin_polyfills_a2ea40e0 from 'nuxt_plugin_polyfills_a2ea40e0' // Source: ../plugins/polyfills (mode: 'all')
import nuxt_plugin_vuedraggable_95781a8a from 'nuxt_plugin_vuedraggable_95781a8a' // Source: ../plugins/vuedraggable (mode: 'all')
import nuxt_plugin_swipe_232621c6 from 'nuxt_plugin_swipe_232621c6' // Source: ../plugins/swipe (mode: 'all')
import nuxt_plugin_evalreq_0b66620e from 'nuxt_plugin_evalreq_0b66620e' // Source: ../plugins/evalreq (mode: 'all')
import nuxt_plugin_vueiframes_23916294 from 'nuxt_plugin_vueiframes_23916294' // Source: ../plugins/vue-iframes (mode: 'all')
import nuxt_plugin_maplibre_6320f990 from 'nuxt_plugin_maplibre_6320f990' // Source: ../plugins/maplibre (mode: 'client')
import nuxt_plugin_googlemaps_15b47544 from 'nuxt_plugin_googlemaps_15b47544' // Source: ../plugins/googlemaps (mode: 'client')
import nuxt_plugin_focus_226b3764 from 'nuxt_plugin_focus_226b3764' // Source: ../plugins/focus (mode: 'all')
import nuxt_plugin_vuetables2_bbda91b6 from 'nuxt_plugin_vuetables2_bbda91b6' // Source: ../plugins/vue-tables-2 (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Lasso","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Lasso Web App"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"stylesheet","href":"https:\u002F\u002Fuse.typekit.net\u002Fnft4waz.css"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.materialdesignicons.com\u002F5.3.45\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"stylesheet","href":"https:\u002F\u002Funpkg.com\u002Fmaplibre-gl@5.22.0\u002Fdist\u002Fmaplibre-gl.css"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_06ef2212 === 'function') {
    await nuxt_plugin_plugin_06ef2212(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_554e15bc === 'function') {
    await nuxt_plugin_bootstrapvue_554e15bc(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_e784d708 === 'function') {
    await nuxt_plugin_recaptcha_e784d708(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7b38fa35 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7b38fa35(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_0358148d === 'function') {
    await nuxt_plugin_axios_0358148d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2228ef02 === 'function') {
    await nuxt_plugin_axios_2228ef02(app.context, inject)
  }

  if (typeof nuxt_plugin_anonaxios_2254e5b6 === 'function') {
    await nuxt_plugin_anonaxios_2254e5b6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_0f19c03d === 'function') {
    await nuxt_plugin_vuelidate_0f19c03d(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_22359951 === 'function') {
    await nuxt_plugin_buefy_22359951(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfills_a2ea40e0 === 'function') {
    await nuxt_plugin_polyfills_a2ea40e0(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedraggable_95781a8a === 'function') {
    await nuxt_plugin_vuedraggable_95781a8a(app.context, inject)
  }

  if (typeof nuxt_plugin_swipe_232621c6 === 'function') {
    await nuxt_plugin_swipe_232621c6(app.context, inject)
  }

  if (typeof nuxt_plugin_evalreq_0b66620e === 'function') {
    await nuxt_plugin_evalreq_0b66620e(app.context, inject)
  }

  if (typeof nuxt_plugin_vueiframes_23916294 === 'function') {
    await nuxt_plugin_vueiframes_23916294(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_maplibre_6320f990 === 'function') {
    await nuxt_plugin_maplibre_6320f990(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_15b47544 === 'function') {
    await nuxt_plugin_googlemaps_15b47544(app.context, inject)
  }

  if (typeof nuxt_plugin_focus_226b3764 === 'function') {
    await nuxt_plugin_focus_226b3764(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetables2_bbda91b6 === 'function') {
    await nuxt_plugin_vuetables2_bbda91b6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
